import * as React from 'react'
import { styled } from '@mui/material/styles'
import { Tooltip as MUIMaterialTooltip } from '@mui/material'
import { TooltipProps, tooltipClasses } from '@mui/material/Tooltip'

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <MUIMaterialTooltip {...props} arrow={false} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
    maxWidth: '300px',
  },
}))

export default function Tooltip(props: TooltipProps) {
  const { children, title, placement, open } = props
  return (
    <div>
      <StyledTooltip title={title} placement={placement} open={open}>
        {children}
      </StyledTooltip>
    </div>
  )
}
